export const getActiveModule = (state) => state.getIn(['ui', 'moduleMenu', 'active'])
export const getActiveTab = (state) => state.getIn(['ui', 'tabs', 'tabs']).find((tab) => tab.get('active')) || null
export const hasModuleLoadedAccessRights = (state, module) =>
    state.getIn(['authorization', 'accessRights', module, 'isCustomLoaded'], false)
export const tabsSelector = (state) => state.getIn(['ui', 'tabs', 'tabs'])
export const tabByIdSelector = (state, tabId) => {
    const tabs = state.getIn(['ui', 'tabs', 'tabs'])

    return tabs.find((tab) => tab.get('id') === tabId) || null
}
